export class NumberOnlyValueConverter {
    toView(value: string) {
        if (typeof value === "number") {
            return value;
        }

        const cleanedValue = (value || "").toString().replace(/\D/g, '') || undefined;
        return cleanedValue;
    }

    fromView(value) {
        if (value === null || value === undefined || value === "") {
            return undefined;
        }

        if (typeof value === "number") {
            return value;
        }

        const cleanedValue = (value || "").toString().replace(/\D/g, '');
        return cleanedValue;
    }
}
